var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc-layout__sidebar"},[_c('avatar'),_c('sidebar-nav'),_c('sidebar-tools')],1)}
var staticRenderFns = []

export { render, staticRenderFns }